export default __webpack_public_path__ + "static/media/cor1.29181b90.jpeg";